import { render, staticRenderFns } from "./LumpSumPayments.vue?vue&type=template&id=83cdee5a&"
import script from "./LumpSumPayments.vue?vue&type=script&lang=ts&"
export * from "./LumpSumPayments.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports